import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextbausteinNew from "../../newForms2/textbausteine/TextbausteinNew";
import TextbausteinList from "./TextbausteinList";
import { fetchTextbausteineFromAPI } from "../../actions/textbausteine";
import Spinner from "../Spinner";
import TextbausteinDetails from "./TextbausteinDetails";

function TextbausteinMain() {
  const [isLoading, setIsLoading] = useState(true);
  const [showFormNew, setShowFormNew] = useState(false);
  const [activeTextbaustein, setActiveTextbaustein] = useState(0);
  // const textbausteine = useSelector(st => st.textbausteine);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetch = async () => {
      dispatch(fetchTextbausteineFromAPI());
      setIsLoading(false);
    };
    if (isLoading) fetch();
  });

  if (isLoading) return <Spinner />;
  // console.log({ activeTextbaustein });
  return (
    <div>
      <div>
        <h3>Textbausteine</h3>
        {!activeTextbaustein && !showFormNew && (
          <button
            className="btn btn-outline-dark"
            onClick={() => setShowFormNew(!showFormNew)}
          >
            Textbaustein hinzufügen
          </button>
        )}
      </div>
      {showFormNew && (
        <TextbausteinNew backFunc={() => setShowFormNew(false)} />
      )}
      {!activeTextbaustein && (
        <TextbausteinList setActiveTextbaustein={setActiveTextbaustein} />
      )}
      {activeTextbaustein && (
        <TextbausteinDetails
          activeTextbaustein={activeTextbaustein}
          backFunc={() => setActiveTextbaustein(0)}
        />
      )}
    </div>
  );
}

export default TextbausteinMain;
